import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, makeStyles } from '@material-ui/core';
import CardHeader from './CardHeader';
import CardContent from './CardContent';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles(theme => ({
  card: {
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'visible',
  },
}));

function Card({ children }) {
  const classes = useStyles();
  return (
    <MuiCard className={classes.card} square>
      {children}
    </MuiCard>
  );
}

Card.propTypes = propTypes;
Card.Header = CardHeader;
Card.Content = CardContent;

export default Card;
